import React from 'react';
import { Center, Container } from '@fiverr-private/layout_components';
import { StandaloneIdentificationForm } from '@fiverr-private/identification_marketplace';
import type { SigningMode, IdentificationRollouts } from '../../../types';
import { ROLLOUTS } from '../../../../configuration/constants';
import * as classes from './Identification.ve.css';
import '../shared/styles/Global.ve.css';

interface IdentificationProps {
  mode: SigningMode;
  rollouts: IdentificationRollouts;
}

const {
  LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP,
  BEETLES_MIGRATE_SIGNUP_WEB,
  BEETLES_MIGRATE_SIGNIN_WEB,
  BEETLES_MIGRATE_SOCIAL_SIGNUP,
} = ROLLOUTS;

export const Identification = ({ mode, rollouts }: IdentificationProps) => (
  <Center paddingY={{ default: '0', md: '10' }}>
    <Container
      className={classes.formBoxShadow}
      height="645px"
      width={{ default: '100%', md: '900px' }}
      maxWidth="100%"
      backgroundColor="white"
      borderRadius="xl"
      overflow="hidden"
    >
      <StandaloneIdentificationForm
        mode={mode}
        inLynxesIdentificationResetPasswordRollout={rollouts[LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP]}
        inBeetlesMigrateSignupWebRollout={rollouts[BEETLES_MIGRATE_SIGNUP_WEB]}
        inBeetlesMigrateSigninWebRollout={rollouts[BEETLES_MIGRATE_SIGNIN_WEB]}
        inBeetlesMigrateSocialSignUpRollout={rollouts[BEETLES_MIGRATE_SOCIAL_SIGNUP]}
      />
    </Container>
  </Center>
);
